export const TWO_STATE_SORTING_TABLE_CONFIG = {
  enableSorting: true,
  enableSortingRemoval: false,
} as const;